export const RESILIENCY_MONITOR_BASE_ROUTE = 'resiliency-monitor';
const RESILIENCY_MONITOR_BASE_PATH = `/${RESILIENCY_MONITOR_BASE_ROUTE}`;
export default RESILIENCY_MONITOR_BASE_PATH;
